import React from 'react';
import { Phone, Mail, Globe, MapPin, Leaf } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Contact() {
  const {
    t
  } = useLanguage();
  const contactInfo = [{
    icon: Phone,
    title: t.contact.info.phone,
    value: '+62 82275757589',
    subtext: '(Mr. Taufik Akh)',
    placeholder: false
  }, {
    icon: Mail,
    title: t.contact.info.email,
    value: 'info@kratomborneo.id',
    placeholder: false
  }, {
    icon: Globe,
    title: t.contact.info.website,
    value: 'kratomborneo.id',
    placeholder: false
  }, {
    icon: MapPin,
    title: t.contact.info.location,
    value: 'Kalimantan, Indonesia',
    placeholder: true
  }];
  return <section id="contact" className="w-full bg-gray-50" data-id="element-19">
      {/* Contact Section */}
      <div className="py-16 md:py-24" data-id="element-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
          {/* Section Header */}
          <div className="text-center mb-12" data-id="element-22">
            <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-23">
              {t.contact.badge}
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-24">
              {t.contact.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-25">
              {t.contact.subtitle}
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-26">
            {contactInfo.map((info, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 text-center" data-id="element-27">
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-28">
                  <info.icon className="w-7 h-7 text-emerald-700" data-id="element-29" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-30">
                  {info.title}
                </h3>
                <p className={`${info.placeholder ? 'text-gray-500' : 'text-emerald-700 font-medium'}`} data-id="element-31">
                  {info.value}
                </p>
                {info.subtext && <p className="text-sm text-gray-500 mt-1" data-id="element-32">{info.subtext}</p>}
              </div>)}
          </div>

          {/* Since Badge */}
          <div className="text-center" data-id="element-33">
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-700 text-white rounded-full" data-id="element-34">
              <Leaf className="w-5 h-5" data-id="element-35" />
              <span className="font-semibold" data-id="element-36">{t.contact.since}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-emerald-800 py-8" data-id="element-37">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-39">
            {/* Logo & Tagline */}
            <div className="flex items-center gap-3" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/t37N25GpwJa9GYRmF4gvMx/1.png" alt="KBIN Logo" className="h-10 w-auto brightness-0 invert" data-id="element-41" />
              <div data-id="element-42">
                <span className="text-white font-bold" data-id="element-43">KBIN</span>
                <span className="text-emerald-300 text-sm block" data-id="element-44">
                  {t.contact.footer.tagline}
                </span>
              </div>
            </div>

            {/* Copyright */}
            <p className="text-emerald-300 text-sm text-center md:text-right" data-id="element-45">
              © {new Date().getFullYear()} {t.contact.footer.copyright}
            </p>
          </div>
        </div>
      </footer>
    </section>;
}